import { PAYMENT_METHOD_IDS } from "../utils/constants";
import { FilteredPaymentMethod } from "../types/store/common";
import { useGlobalStore, useOrderStore } from "../store/hooks/useStore";
import { FetchPaymentMethodsPayload } from "braintree-web";
import {vars} from '../vanilla/vars.css'

type Colours = keyof typeof vars.color

interface PaymentMethodData {
    isAvailable: boolean
    isDisabled: boolean
    isLoading: boolean,
    name: string,
    buttonColour: Colours
    customIconURL?: string
}

export const usePaymentMethodData = (paymentMethod: FetchPaymentMethodsPayload | FilteredPaymentMethod): PaymentMethodData => {
        let isAvailable = true
        let isDisabled = false
        let isLoading = true
        let name = '' 
        let customIconURL
        let buttonColour: Colours = 'black'
        const { klarnaSetupData, clearpaySetupData } = useOrderStore()
        const globalStore = useGlobalStore()
        
        if('id' in paymentMethod) {
            name = paymentMethod.name
            switch (paymentMethod.id) {
                case PAYMENT_METHOD_IDS.PAYPAL:
                    buttonColour = 'paypalButton'
                    break;
                case PAYMENT_METHOD_IDS.KLARNA:
                    isAvailable = klarnaSetupData.client_token !== undefined
                    isDisabled = !klarnaSetupData.show_form
                    isLoading = !klarnaSetupData.button_rendered
                    name = klarnaSetupData.category?.name || paymentMethod.name
                    customIconURL = klarnaSetupData.category?.asset_urls?.standard || undefined
                    buttonColour = 'none'
                    break;
                case PAYMENT_METHOD_IDS.APPLE_PAY:
                    isLoading = !globalStore.hasApplePayButtonRendered
                    break;
                case PAYMENT_METHOD_IDS.CLEARPAY:
                    isAvailable = clearpaySetupData.token !== undefined
                    isLoading = !clearpaySetupData.button_rendered
                    buttonColour = 'none'
                    break;
                default:
                    break;
            }
        }

        return {
            isAvailable,
            isLoading,
            isDisabled,
            name,
            customIconURL,
            buttonColour
        }
}